// @flow
import React, { type Node } from 'react';
import { I18n } from '@lingui/react';
import { CardExpiryElement } from 'react-stripe-elements';

import StripeFormGroup, { createStyledStripeElement } from './StripeFormGroup';

const StyledCardExpiryElement = createStyledStripeElement(CardExpiryElement);

export type Props = {};

const StripeCreditCardExpiryField = (props: Props): Node => (
  <I18n>
    {({ i18n }) => (
      <StripeFormGroup {...props} label={i18n._('Expiration')}>
        {formGroupProps => (
          <StyledCardExpiryElement {...formGroupProps} placeholder={i18n._('MM/YY')} />
        )}
      </StripeFormGroup>
    )}
  </I18n>
);

export default StripeCreditCardExpiryField;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/StripeCreditCardForm/StripeCreditCardExpiryField.jsx